/**
 * Create by Baizhiming 2015-11-30
 * 传稿
 */
'use strict';
angular.module('iWoDraftModule', []).controller('iWoDraftCtrl', ['$scope', '$timeout', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'incomeData', 'editingCenterService',
    function ($scope, $timeout, $modalInstance, trsHttpService, trsspliceString, modalDialog, incomeData, editingCenterService) {
        init();
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        $scope.showToggle = function (node) {
            childrenTree(node, function () { });
        };
        $scope.chooseUser = function (user) {
            if (angular.isDefined(user.selected) && user.selected === 'selected') {
                $scope.selectedUser = {};
                user.selected = '';
            } else {
                if (angular.isDefined($scope.oldUser)) {
                    $scope.oldUser.selected = '';
                }
                $scope.selectedUser = user;
                user.selected = 'selected';
                $scope.oldUser = user;
            }
        };
        $scope.confirm = function () {
            if (JSON.stringify($scope.selectedUser) === '{}') {
                modalDialog.alertType('提示信息', '请选择用户', 'warning', false, function () { });
            } else if ($scope.status.confirm) { // 为了兼容以前逻辑，如果confirm为true，则把选中人对象传出
                $modalInstance.close($scope.selectedUser);
            } else {
                if (incomeData.array !== '') {
                    var params = {
                        'serviceid': 'mlf_myrelease',
                        'methodname': incomeData.methodname,
                        'ChnlDocIds': trsspliceString.spliceString(incomeData.array, 'CHNLDOCID', ','),
                        'UserId': angular.isDefined($scope.selectedUser.ID) ? $scope.selectedUser.ID : $scope.selectedUser.OPERID
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('传稿成功', '', 'success', false, function () {
                            $modalInstance.close('success');
                        });
                    }, function () {
                        $modalInstance.close('fail');
                    });
                } else {
                    $modalInstance.close({
                        'ID': angular.isDefined($scope.selectedUser.ID) ? $scope.selectedUser.ID : $scope.selectedUser.OPERID,
                        'GROUPID': $scope.groupObj.GROUPID,
                        'USERNAME': $scope.oldUser.USERNAME
                    });
                }
            }
        };

        $scope.showSelected = function (node) {
            $timeout(function () {
                // 此判断如果两次点击同一个树，不重复加载角色列表。
                if ($scope.oldSelectNode !== undefined && node.GROUPID == $scope.oldSelectNode.GROUPID) {
                    return;
                }
                $scope.groupObj = node;
                $scope.oldSelectNode = node;
                $scope.Datas = [];
                $scope.userData = null;
                var params = {
                    'serviceid': 'mlf_group',
                    'methodname': 'getUsersByGroup',
                    'GroupId': $scope.groupObj.GROUPID
                };
                // trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                    $scope.users = data;
                });
            },
            100);
        };
        $scope.getSuggestions = function (viewValue) {
            if (viewValue !== '') {
                var searchUsers = {
                    serviceid: 'mlf_extuser',
                    methodname: 'searchUserOrDept',
                    Name: viewValue
                };
                if ($scope.isRequest) {
                    $scope.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'get').then(function (data) {
                        var i = data.length - 1;
                        while (i >= 0) {
                            if (data[i].TYPE === '201') {
                                data.splice(i, 1);
                            }
                            i--;
                        }
                        return data;
                    });
                }
            }
        };
        $scope.$watch('searchWord', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                $scope.isRequest = true;
                $scope.users = [newValue];
                $scope.searchWord = newValue.USERNAME;
            }
        });

        /**
         * [init description]
         *
         * @return  {[type]}  [return description]
         */
        function init() {
            $scope.status = incomeData;
            $scope.isRequest = false;
            // 组织树配置文件
            $scope.treeOptions = editingCenterService.channelTreeOptions();
            // $scope.treeOptions = {
            //     nodeChildren: 'CHILDREN',
            //     dirSelectable: true,
            //     allowDeselect: false,
            //     injectClasses: {
            //         ul: 'a1',
            //         li: 'a2',
            //         liSelected: 'a7',
            //         iExpanded: 'a3',
            //         iCollapsed: 'a4',
            //         iLeaf: 'a5',
            //         label: 'a6',
            //         labelSelected: 'a8'
            //     },
            //     isLeaf: function(node) {
            //         return node.HASCHILDREN == 'false';
            //     }
            // };
            var treeParams = {
                'serviceid': 'mlf_group',
                'methodname': 'queryGroupTreeWithMyPath'
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', treeParams, 'get')
                .then(function (data) {
                    $scope.treedata = [data];
                    ExpandedNodes();
                }, function (data) { });
            if (angular.isDefined($scope.status.records)) { // 判断 如果有传入最近传稿人，则用传入的
                $scope.records = $scope.status.records;
            } else { // iwo 跟人稿库传稿最近传稿人
                var recordParams = {
                    'serviceid': 'mlf_myrelease',
                    'methodname': 'getTransferedRecord'
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', recordParams, 'get')
                    .then(function (data) {
                        $scope.records = data;
                    }, function (data) { });
            }
            $scope.selectedUser = {};
            $scope.recordNum = 6;
        }

        /**
         * [childrenTree description]
         *
         * @param   {[type]}  node      [node description]
         * @param   {[type]}  callback  [callback description]
         *
         * @return  {[type]}            [return description]
         */
        function childrenTree(node, callback) {
            if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                var paramsT = {
                    'serviceid': 'mlf_group',
                    'methodname': 'queryChildGroupsWithOutRight',
                    'GroupId': node.GROUPID
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', paramsT, 'get').then(function (dataC) {
                    node.CHILDREN = dataC.CHILDREN;
                    callback();
                });
            }
        }

        /**
         * [ExpandedNodes description]默认树展开
         *
         * @return  {[type]}  [return description]
         */
        function ExpandedNodes() {
            $scope.expandedTest = [];
            var flag = true;
            $scope.expandedTest.push($scope.treedata[0]);
            angular.forEach($scope.treedata[0].CHILDREN, function (data, index, array) {
                if (data.ISPATH === 'true') {
                    flag = false;
                    if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                        $scope.expandedTest.push(data);
                        selfPath(data);
                    } else {
                        $scope.selectedNode = data;
                        getGroupData($scope.selectedNode);
                    }
                }
            });
            if (flag) {
                $scope.selectedNode = $scope.treedata[0];
                getGroupData($scope.selectedNode);
            }
        }

        /**
         * [getGroupData description]
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        function getGroupData(node) {
            $timeout(function () {
                $scope.groupObj = node;
                var params = {
                    'serviceid': 'mlf_group',
                    'methodname': 'getUsersByGroup',
                    'GroupId': $scope.groupObj.GROUPID
                };
                // trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                    $scope.users = data;
                });
            },
            100);
        }

        /**
         * [selfPath description]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function selfPath(data) {
            for (var i = 0; i < data.CHILDREN.length; i++) {
                if (data.CHILDREN[i].ISPATH === 'true') {
                    if (data.CHILDREN[i].HASCHILDREN === 'false' || data.CHILDREN[i].CHILDREN.length === 0) {
                        $scope.selectedNode = data.CHILDREN[i];
                        getGroupData($scope.selectedNode);
                        break;
                    } else {
                        $scope.expandedTest.push(data.CHILDREN[i]);
                        selfPath(data.CHILDREN[i]);
                        break;
                    }
                }
            }
        }

    }
]);
